/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { LmsException } from './../../../core/model/lms-exception.model';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { ShopLocation } from './../../../core/model/shop-location.model';
import { TerminalCommonInfo } from './../../../core/model/terminal-common-info.model';
import { TripPlanException } from './../../../core/model/trip-plan-exception.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { EditModeService } from './../../../core/services/edit-mode.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { UtilService } from './../../../core/services/util.service';
import { SaveAddToPendingList } from './../../shared/model/terminal-pending.model';
import { AddToPendingService } from './../../shared/services/add-to-pending.service';



@Component({
  selector: 'lms-terminal-pending-actions',
  templateUrl: './lms-terminal-pending-actions.component.html',
  styleUrls: ['./lms-terminal-pending-actions.component.scss']
})
export class LmsTerminalPendingActionsComponent implements OnInit, OnDestroy {
  @Input() lmsExceptionList;
  @Input() allStatusdata;
  @Output() submitPendingAction = new EventEmitter<any>();
  private addToPendingSubscribe: any;
  anypendingChecked: Boolean = true;
  selectAll: Boolean = true;
  pendingActions = [];
  tripPlanExceptionArr: Array<TripPlanException>;
  qShopLocationArr: Array<ShopLocation>;
  filteredResults: string[] = [];
  terminalSearchText: string;
  summary: TerminalCommonInfo;
  commonopsPicklist: any;

  constructor(private addToPendingService: AddToPendingService,
    private editModeService: EditModeService, private utilService: UtilService,
    private appUtilityService: AppUtilityService,
    private staticDataStoreService: StaticDataStoreService) {
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.addToPendingSubscribe = this.addToPendingService.terminalPL$.subscribe(data => {
      this.pendingActions = data['pendingList'];
      this.setDefaultTripPlanQShoDate();
      this.checkAllCheckedOrNot();
      this.checkNeedToSubmitAction();
    });
  }

  private checkNeedToSubmitAction() {
    for (let i = 0; i < this.pendingActions.length; i++) {
      if (this.pendingActions[i].submitPendingList) {
        this.triggerPendingAction();
        this.pendingActions[i].submitPendingList = false;
        break;
      }
    }
  }
  toggleSelectAll() {
    this.checkUncheckLocos(this.selectAll);
  }

  triggerPendingAction() {
    this.submitPendingAction.emit();
  }

  /**
   * this method is use to trigger respectice checkbox change event
   * by this when you click on row then it will check uncheck the checkbox
   * @param {any} index
   * @param {any} trainIndex
   * @param {any} type
   * @param {any} event
   * @memberof LmsTerminalPendingActionsComponent
   */
  changeCheckbox(index, trainIndex, type, event) {
    const inputElement = document.getElementById(index + '-' + trainIndex + type);
    if (inputElement) {
      inputElement.dispatchEvent(new Event('change'));
    }
  }

  changeAllPendingActionCheckbox(id, event) {
    const inputElement = document.getElementById(id);
    if (inputElement) {
      inputElement.dispatchEvent(new Event('change'));
    }
  }
  changeLocoStatus(index: number, typeindex: number, type: string) {
    this.checkAllCheckedOrNot();
  }

  private checkAllCheckedOrNot() {
    let checkedcounter = 0;
    let totalcounter = 0;
    const pendingActionsLength = this.pendingActions ? this.pendingActions.length : 0;
    const checkTrainTypeOperation = this.checkTrainOpertaion();

    for (let i = 0; i < pendingActionsLength; i++) {

      if (checkTrainTypeOperation) {
        for (const train of this.pendingActions[i].trains) {
          totalcounter++;
          if (train['checked'] === true) {
            checkedcounter++;
          }
        }
      } else {
        if (this.pendingActions[i].action === 'resequence' || this.pendingActions[i].action === 'CancelTrainLocomotivePlan') {
          for (const train of this.pendingActions[i].trains) {
            totalcounter++;
            if (train['checked'] === true) {
              checkedcounter++;
            }
          }
        } else {
          for (const loco of this.pendingActions[i].locos) {
            totalcounter++;
            if (loco['checked'] === true) {
              checkedcounter++;
            }
          }
        }

      }
    }
    this.anypendingChecked = checkedcounter ? true : false;
    this.addToPendingService.updatePendingListStatus(this.anypendingChecked);
    this.selectAll = (totalcounter === checkedcounter);
    return (totalcounter === checkedcounter);
  }
  /**
   * this method mainly use to check
   * uncheck the state of all locos of pendig list
   * @private
   * @param {Boolean} checkStatus
   * @memberOf LmsTerminalPendingActionsComponent
   */
  private checkUncheckLocos(checkStatus: Boolean) {
    const pendingActionsLength = this.pendingActions.length;
    if (pendingActionsLength) {
      for (let i = 0; i < pendingActionsLength; i++) {
        for (const loco of this.pendingActions[i].locos) {
          loco['checked'] = checkStatus;
        }
        for (const train of this.pendingActions[i].trains) {
          train['checked'] = checkStatus;
        }

      }
      this.anypendingChecked = checkStatus;
      this.addToPendingService.updatePendingListStatus(this.anypendingChecked);
    }

  }

  private checkTrainOpertaion() {
    return _.filter(this.pendingActions, (item) => {
      return item['action'] === 'complete' || item['action'] === 'cancel';
    }).length;
  }

  deletePendingList() {
    const pendingActionsLength = this.pendingActions.length;
    if (pendingActionsLength) {
      for (let i = pendingActionsLength - 1; i >= 0; i--) {
        if (!this.checkTrainOpertaion()) {
          // to remove locos in pending list object
          const locosLength = this.pendingActions[i].locos.length;
          if (locosLength) {

            if (this.pendingActions[i].action !== 'resequence' && this.pendingActions[i].action !== 'CancelTrainLocomotivePlan') {
              for (let j = locosLength - 1; j >= 0; j--) {
                if (this.pendingActions[i].locos[j].checked) {
                  this.pendingActions[i].locos[j].isSubmitBreLoco = false;
                  this.pendingActions[i].locos[j].isLmsExceptionExist = false;
                  this.setLocoTrainPendindStatus('locos', false, this.pendingActions[i].locos[j]);
                  delete this.pendingActions[i].locos[j];
                }
              }
              this.pendingActions[i].locos = this.utilService.removeUndefinedInArray(this.pendingActions[i].locos);
            } else {
              // to remove trains in pending list object
              const trainsLength = this.pendingActions[i].trains.length;
              if (trainsLength) {
                for (let k = trainsLength - 1; k >= 0; k--) {
                  if (this.pendingActions[i].trains[k].checked) {
                    this.setTrainResequenceStatus(this.pendingActions[i].trains[k]);
                    delete this.pendingActions[i].trains[k];
                  }
                }
                this.pendingActions[i].trains = this.utilService.removeUndefinedInArray(this.pendingActions[i].trains);
              }
            }
          }
        }

        if (this.checkTrainOpertaion()) {
          // to remove trains in pending list object
          const trainsLength = this.pendingActions[i].trains.length;
          if (trainsLength) {
            for (let k = trainsLength - 1; k >= 0; k--) {
              if (this.pendingActions[i].trains[k].checked) {
                this.setLocoTrainPendindStatus('trains', false, this.pendingActions[i].trains[k]);
                delete this.pendingActions[i].trains[k];
              }
            }
            this.pendingActions[i].trains = this.utilService.removeUndefinedInArray(this.pendingActions[i].trains);
          }
        }

        if ((this.pendingActions[i].action === 'resequence' || this.pendingActions[i].action === 'CancelTrainLocomotivePlan' || this.checkTrainOpertaion()) && !this.pendingActions[i].trains.length) {
          this.pendingActions.splice(i, 1);
        } else if (!this.checkTrainOpertaion() && !this.pendingActions[i].locos.length) {
          this.pendingActions.splice(i, 1);
        }

      }

      // if no pending action exist then remove edit mode
      if (!this.pendingActions.length) {
        this.removeEditMode();
      }
      this.checkAllCheckedOrNot();
      this.addToPendingService.deleteInPendingList(this.pendingActions);

    }
  }

  private setTrainResequenceStatus(train) {
    const outBoundTrain = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const outBoundLength = outBoundTrain.length;
    for (let q = 0; q < outBoundLength; q++) {
      if (outBoundTrain[q].trainIdentifier === train.trainIdentifier) {
        outBoundTrain[q].locoDetails = _.sortBy(outBoundTrain[q].locoDetails, ['loadOrder']);
        for (let s = 0; s < outBoundTrain[q].locoDetails.length; s++) {
          outBoundTrain[q].locoDetails[s].resequenceOrder = s;
          this.setcheckClickInPending(outBoundTrain[q].locoDetails[s], false);
        }
        // now reset train
        this.setcheckClickInPending(outBoundTrain[q], false);
        break;
      }
    }

    const inBoundTrain = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const inBoundLength = inBoundTrain.length;
    for (let q = 0; q < inBoundLength; q++) {
      if (inBoundTrain[q].trainIdentifier === train.trainIdentifier) {
        inBoundTrain[q].locoDetails = _.sortBy(inBoundTrain[q].locoDetails, ['loadOrder']);
        for (let s = 0; s < inBoundTrain[q].locoDetails.length; s++) {
          inBoundTrain[q].locoDetails[s].resequenceOrder = s;
          this.setcheckClickInPending(inBoundTrain[q].locoDetails[s], false);
        }
        // now reset train
        this.setcheckClickInPending(inBoundTrain[q], false);
        break;
      }
    }
  }



  private setLocoTrainPendindStatus(type: string, status: Boolean, locoTrainData: Object) {
    const inBoundTrain = this.allStatusdata.terminalStatusIO.inBoundTrains;
    const inBoundLength = inBoundTrain.length;
    const outBoundTrain = this.allStatusdata.terminalStatusIO.outBoundTrains;
    const outBoundLength = outBoundTrain.length;
    const terminalList = this.allStatusdata.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];

    const terminalListLength = totalTerminalListLocos.length;


    if (type === 'trains') {
      // checking for train
      for (let i = 0; i < inBoundLength; i++) {
        if (inBoundTrain[i].trainIdentifier === locoTrainData['trainIdentifier']) {
          this.setcheckClickInPending(inBoundTrain[i], status);
        }
      }

      for (let i = 0; i < outBoundLength; i++) {
        if (outBoundTrain[i].trainIdentifier === locoTrainData['trainIdentifier']) {
          this.setcheckClickInPending(outBoundTrain[i], status);
        }
      }

    }

    if (type === 'locos') {

      for (let i = 0; i < inBoundLength; i++) {
        // checking for inBoundTrain locos
        for (let j = 0; j < inBoundTrain[i].locoDetails.length; j++) {
          //if (locoTrainData['trainLocoMixId'] === inBoundTrain[i].locoDetails[j].trainLocoMixId) {
          if ((locoTrainData['trainLocoMixId'] === inBoundTrain[i].locoDetails[j].trainLocoMixId) || 
          (this.appUtilityService.removeSpaceLocomotiveId(locoTrainData['locomotiveIdentifier']) === this.appUtilityService.removeSpaceLocomotiveId(inBoundTrain[i].locoDetails[j]['locomotiveIdentifier']))
          ) { 
            this.setcheckClickInPending(inBoundTrain[i].locoDetails[j], status);
          }
        }
      }

      for (let i = 0; i < outBoundLength; i++) {
        for (let j = 0; j < outBoundTrain[i].locoDetails.length; j++) {
          //if (locoTrainData['trainLocoMixId'] === outBoundTrain[i].locoDetails[j].trainLocoMixId) {
          if ((locoTrainData['trainLocoMixId'] === outBoundTrain[i].locoDetails[j].trainLocoMixId) || 
          (this.appUtilityService.removeSpaceLocomotiveId(locoTrainData['locomotiveIdentifier']) === this.appUtilityService.removeSpaceLocomotiveId(outBoundTrain[i].locoDetails[j]['locomotiveIdentifier']))
          ) { 
            this.setcheckClickInPending(outBoundTrain[i].locoDetails[j], status);
          }
        }
      }

      // checking in terminal list locos
      for (let j = 0; j < terminalListLength; j++) {
        if (!_.isEmpty(totalTerminalListLocos[j])) {
          for (let k = 0; k < totalTerminalListLocos[j].length; k++) {
            // if (locoTrainData['trainLocoMixId'] === totalTerminalListLocos[j][k].trainLocoMixId) {
            if ((locoTrainData['trainLocoMixId'] === totalTerminalListLocos[j][k].trainLocoMixId) || 
            (this.appUtilityService.removeSpaceLocomotiveId(locoTrainData['locomotiveIdentifier']) === this.appUtilityService.removeSpaceLocomotiveId(totalTerminalListLocos[j][k]['locomotiveIdentifier']))
            ) { 
              this.setcheckClickInPending(totalTerminalListLocos[j][k], status);
            }
          }
        }
      }
    }

  }

  private setcheckClickInPending(item: Object, status: Boolean) {
    item['inPendingList'] = status;
    item['checked'] = status;
    item['clicked'] = status;
    item['order'] = status ? item['order'] : 0;
  }

  private removeEditMode() {
    this.editModeService.setEditMode({
      status: false,
      message: '',
      nextUrl: '',
      callback: () => { }
    });
  }
  private addPendingAction(pendingItem) {

  }

  ngOnInit() {
    this.tripPlanExceptionArr = [];
    this.qShopLocationArr = [];
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist && commonopsPicklist.masterData) {
      if (commonopsPicklist.masterData.tripPlanExceptionList) {
        this.tripPlanExceptionArr = commonopsPicklist.masterData.tripPlanExceptionList;
      }
      if (commonopsPicklist.masterData.shopLocationList) {
        this.qShopLocationArr = this.removeDuplicates(commonopsPicklist.masterData.shopLocationList, 'shopCode');
      };
    }

  }

  ngOnDestroy() {
    this.addToPendingSubscribe.unsubscribe();
  }

  save(model: SaveAddToPendingList) {
    // call API to save customer
  }

  getLmsExceptionForLoco(locoId: string): LmsException {
    return _.find(this.lmsExceptionList, { 'locoId': this.appUtilityService.formatLocomotiveId(locoId) });
  }


  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  setTripPlanException(locoDetails: LocoDetail) {
    if (locoDetails) {
      if (locoDetails.tripPlanOverrideCode !== 'Other') {
        const tripPlanException = _.find(this.tripPlanExceptionArr,
          { 'reasonCode': locoDetails.tripPlanOverrideCode });
        if (tripPlanException && tripPlanException.reasonDescription) {
          locoDetails.tripPlanOverrideReason = tripPlanException.reasonDescription;
        }
        locoDetails.tripPlanOtherReason = '';
      } else {
        locoDetails.tripPlanOverrideCode = 'TEXT'; // AS PER VB shop code
        locoDetails.tripPlanOverrideReason = 'Other';
      }
      locoDetails.isLmsExceptionInAddReason = false;
    }
  }

  setQShopLocationDate(locoDetails) {
    if (locoDetails) {
      if (locoDetails.unscheduledQShopMnemonic) {
        const unscheduledQShopArr = _.split(locoDetails.unscheduledQShopMnemonic, '-');
        if (unscheduledQShopArr && unscheduledQShopArr.length === 2 && locoDetails.unscheduledQShopDate) {
          locoDetails.unscheduledQShop = unscheduledQShopArr[1].trim();
          locoDetails.unscheduledQShopDateDesc = locoDetails.unscheduledQShopMnemonic.trim() + ' ' +
            locoDetails.unscheduledQShopDate.trim();
          locoDetails.isLmsExceptionInAddQShop = false;
        }
      }
    }
  }

  getTripPlanReason(tripPlanCode: string): string {
    let tripPlanReason;
    const tripPlanException = _.find(this.tripPlanExceptionArr, { 'reasonCode': tripPlanCode });
    if (tripPlanException) {
      tripPlanReason = tripPlanException.reasonDescription;
    }
    return tripPlanReason;
  }

  setDefaultTripPlanQShoDate() {
    let tripPlanException: TripPlanException;
    if (this.tripPlanExceptionArr && this.tripPlanExceptionArr.length > 0) {
      tripPlanException = this.tripPlanExceptionArr[0];
    }
    let shopLocation: ShopLocation;
    if (this.qShopLocationArr && this.qShopLocationArr.length > 0) {
      shopLocation = this.qShopLocationArr[0];
    }
    if (this.pendingActions) {
      const pendingActionsLength = this.pendingActions.length;
      for (let i = 0; i < pendingActionsLength; i++) {
        if (this.pendingActions[i].locos) {
          for (let j = 0; j < this.pendingActions[i].locos.length; j++) {
            if (tripPlanException) {
            }
            if (shopLocation) {
            }
            if (this.lmsExceptionList) {
              for (let k = 0; k < this.lmsExceptionList.length; k++) {
              }
            }
          }
        }
      }
    }
  }

  trackByTrainIdentifier(index, item) {
    return item.trainIdentifier;
  }

  trackByLocomotiveIdentifier(index, item) {
    return item.locomotiveIdentifier;
  }

  /**
   * Autocomplete for terminal selection.
   * @param {any} event
   * @memberOf LmsTerminalPendingActionsComponent
   */
  autoCompleteForTerminal(event) {
    const mnemonics = [];
    if (this.commonopsPicklist) {
      if (this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.shopLocationList) {
        for (let i = 0; i < this.commonopsPicklist.masterData.shopLocationList.length; i++) {
          mnemonics.push(this.commonopsPicklist.masterData.shopLocationList[i].terminalMnemonic);
        }
      }
    }
    this.filteredResults = mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * Select terminal menmonic from autocomplete terminal mnemonic.
   * @param {string} value
   * @memberOf LmsTerminalPendingActionsComponent
   */
  selectValueFromAutoComplete(value: string, locoDetails: LocoDetail) {
    if (value) {
      if (this.commonopsPicklist && this.commonopsPicklist.setOfTerminals) {
        const terminalCommonInfoArr = this.commonopsPicklist.setOfTerminals;
        if (terminalCommonInfoArr) {
          this.summary = _.find(terminalCommonInfoArr,
            { 'terminalMnemonic': value.trim().toUpperCase() });
          if (this.summary) {
            if (this.summary.city) {
              this.summary.city = this.summary.city.trim();
            }
            if (this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.divisonList) {
              const divisionArr = this.commonopsPicklist.masterData.divisonList;
              if (divisionArr && this.summary) {
                const divisionObj: TerminalCommonInfo = _.find(divisionArr, { 'divisionCode': this.summary.divisionCode });
                if (divisionObj) {
                  this.summary.divisionName = divisionObj.divisionName;
                }
              }
            }
          }
        }
      }
      const shopLocation = _.find(this.qShopLocationArr,
        { 'terminalMnemonic': value });
      if (shopLocation) {
        locoDetails.unscheduledQShopMnemonic = value + '-' + shopLocation.shopCode;
      }
    }
  }

  /**
   * Remove search text on terminal mnemonic.
   * @memberOf LmsTerminalPendingActionsComponent
   */
  removeSearchText(locoDetails: LocoDetail) {
    this.terminalSearchText = '';
    this.summary = null;
    locoDetails.unscheduledQShopMnemonic = '';
    locoDetails.unscheduledQShopDateDesc = '';
  }

}
